import ShareService from "@/lib/ShareService";
import { toast } from "sonner";

// Share via the backend preview URL so WhatsApp/social crawlers get the
// event's own cover/title; people are redirected to /live/events/{id}.
export const eventShareUrl = (eventId) =>
  `${window.location.origin}/api/share/event/${eventId}`;

// Native share sheet when available (mobile), otherwise Copy Link.
export const shareEvent = async (ev) => {
  const url = eventShareUrl(ev.event_id);
  if (ShareService.canNativeShare()) {
    const res = await ShareService.share({
      title: ev.title,
      text: `Join me for "${ev.title}" on RGM Studio Live`,
      url,
    });
    if (res === "shared" || res === "cancelled") return res;
  }
  const ok = await ShareService.copyLink(url);
  if (ok) toast.success("Event link copied");
  else toast.error("Could not copy the link");
  return ok ? "copied" : "failed";
};
